import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchEStoreCatalogList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/eStoreCatalog/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            commit('setEStoreCatalogList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchEStoreCatalogRequest = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/eStoreCatalog/fetchEStoreCatalogRequest.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchEStoreCatalogRequest', payload)
            } else {
                commit('setEStoreCatalogRequestList', res.data.response)         
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchEStoreCatalogData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/eStoreCatalog/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setEStoreCatalogData', {response: res.data.response, copy: payload.copy})   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }
            
        } else {
            commit('resetEStoreCatalogData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitEStoreCatalogData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/eStoreCatalog/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0 && !payload.popup) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            dispatch('fetchEStoreCatalogData', {id: res.data.id})
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteEStoreCatalogData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/eStoreCatalog/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else if(payload.popup) {
            } else {
                dispatch('fetchEStoreCatalogList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreCatalog/actions.js